import { render, staticRenderFns } from "./dividendreport.vue?vue&type=template&id=2562582c&scoped=true"
import script from "./dividendreport.vue?vue&type=script&lang=js"
export * from "./dividendreport.vue?vue&type=script&lang=js"
import style0 from "./dividendreport.vue?vue&type=style&index=0&id=2562582c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562582c",
  null
  
)

export default component.exports